module.exports = __webpack_public_path__ + "img/ad1.ee94dc8c.gif";